// Forms/Import DSL — runtime API client (admin). Wraps the Phase-2b endpoints:
// analyze a script into a Plan, run a widget's query, fire a resolved action.
import { api } from './api.js';

// analyzeForm(script) → { plan }
export const analyzeForm = (script) =>
  api.post('/api/tools/forms-dsl/analyze', { script });

// runQuery(connId, { database, query, binds, terms, mode, limit }) → { columns, rows, truncated }
export const runQuery = (connId, body) =>
  api.post(`/api/connections/${connId}/forms-dsl/query`, body);

// runAction(connId, { database, dryRun, steps }) → { ok, aborted, message, rowsAffected, dryRun }
export const runAction = (connId, body) =>
  api.post(`/api/connections/${connId}/forms-dsl/action`, body);

// Saved DSL forms (CRUD, admin).
export const listForms  = ()        => api.get('/api/forms-dsl');
export const getForm    = (id)      => api.get(`/api/forms-dsl/${id}`);
export const createForm = (body)    => api.post('/api/forms-dsl', body);
export const updateForm = (id, body) => api.put(`/api/forms-dsl/${id}`, body);
export const deleteForm = (id)      => api.delete(`/api/forms-dsl/${id}`);

// Secure run-by-id (any granted user): the server drives the stored script.
// listAccessibleForms() → { forms }            (admin: all; else granted)
// getFormPlan(id) → { plan, connectionId, database }
// runFormQuery(id, { node, binds, terms, mode, limit, searchCols, searchTerm })
// runFormAction(id, { dryRun, steps })
export const listAccessibleForms = ()        => api.get('/api/forms-dsl/accessible');
export const getFormPlan         = (id)      => api.get(`/api/forms-dsl/${id}/plan`);
export const runFormQuery        = (id, body) => api.post(`/api/forms-dsl/${id}/run-query`, body);
export const runFormAction       = (id, body) => api.post(`/api/forms-dsl/${id}/run-action`, body);

// Per-user grants for DSL forms (admin/subadmin).
export const getDslFormGrants = (userId)        => api.get(`/api/users/${userId}/dsl-form-grants`);
export const setDslFormGrants = (userId, formIds) => api.put(`/api/users/${userId}/dsl-form-grants`, { formIds });
